import { getStorage, hasStorage, setStorage, setPersistCheckoutFromStorage, getPersistCheckoutFromStorage } from './storageHelpers'

const addToCartRequest = async (payload, addToShoppingRequest) => {
  const shoppingReqFromStorageObject = getPersistCheckoutFromStorage()
  const shoppingReqObj = hasStorage('persist:checkout')
    ? {
        shoppingRequest: shoppingReqFromStorageObject.shoppingRequest
          ? shoppingReqFromStorageObject.shoppingRequest
          : null,
        lineLevelSessionInfos:
          shoppingReqFromStorageObject.lineLevelSessionInfos
            ? shoppingReqFromStorageObject.lineLevelSessionInfos
            : null,
        invalidIds: shoppingReqFromStorageObject.invalidIds
          ? shoppingReqFromStorageObject.invalidIds
          : null,
      }
    : { shoppingRequest: null, lineLevelSessionInfos: null, invalidIds: null }

  const itemsAddedToCart = payload.reduce((acc, item) => {
    const addedCartItem = [
      {
        contractId: '',
        materialId: item.materialID || item.materialId,
        quantity: item.quantity,
        accessories: item.hasAccessories,
        warranties: item.warrantyMaterialIds?.length > 0 || false,
        warrantyMaterialId:
          item.warrantyMaterialId /** These 2 fields added to support child material ID, if it has **/,
        warrantyQuantity: item.warrantyQuantity,
      },
    ]
    return acc.concat(addedCartItem)
  }, [])

  const cart = await addToShoppingRequest({
    locale: payload[0].locale,
    materialList: itemsAddedToCart,
    ...shoppingReqObj,
  })

  setPersistCheckoutFromStorage(
    'persist:checkout',
    JSON.stringify({
      ...shoppingReqFromStorageObject,
      shoppingRequest: JSON.stringify(cart.shoppingRequest),
      lineLevelSessionInfos: JSON.stringify(cart.lineLevelSessionInfos),
      invalidIds: JSON.stringify(cart.invalidIds),
    })
  )
  window.postMessage({ type: 'cart:add' }, window.location.origin)
  return cart
}

export default addToCartRequest
